import { Action, combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth.slice';
import userReducer from './user.slice';
import { initialRootState } from '../store';
import { logout } from '../thunks/auth.thunk';

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
});

// @ts-ignore please leave the ts ignore for now for store and state related config files
export const rootReducer = (state, action: Action<string>) => {
  if (action.type === logout.fulfilled.type) {
    return appReducer(initialRootState, action);
  }

  return appReducer(state, action);
};
